import api from './api';

export const reportService = {
  // Reportes existentes
  getMonthlyBalanceAfterTeacherPayments: (params?: any) => 
    api.get('/reports/monthly-balance-after-teacher-payments', { params }),
  
  getStudentsWithoutPayment: (params?: any) => 
    api.get('/reports/students-without-payment2', { params }),
  
  // Nuevos reportes
  getIncomeVsExpenses: (params?: any) => 
    api.get('/reports/income-vs-expenses', { params }),
  
  getTopDonors: (params?: any) => 
    api.get('/reports/top-donors', { params }),
  
  getExpensesByCategory: (params?: any) => 
    api.get('/reports/expenses-by-category', { params }),

   exportStudentsWithoutPaymentExcel: (params?: any) => 
    api.get('/reports/students-without-payment/export-excel', { 
      params,
      responseType: 'blob' 
    }),
  
  exportStudentsWithoutPaymentPDF: (params?: any) => 
    api.get('/reports/students-without-payment/export-pdf', { 
      params,
      responseType: 'blob' 
    }),
    
  getStudentsMissingPayment: (params?: any) => 
    api.get('/reports/students-missing-payment', { params }),
  
  exportMissingPaymentExcel: (params?: any) => 
    api.get('/reports/students-missing-payment/export-excel', { 
      params, 
      responseType: 'blob' 
    }),
  
  exportMissingPaymentPDF: (params?: any) => 
    api.get('/reports/students-missing-payment/export-pdf', { 
      params, 
      responseType: 'blob' 
    })
};